import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { jsx } from '@emotion/core'; // @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase

import { arrowDown_16, arrowUp_16 } from '@trustpilot/icons';
import { useLocalization } from '../../../localization';
import * as translations from '../localization';
import { Icon } from '../../Icon';
import { useToggle, cloneElementWithCss } from '../../shared';
import Dropdown from '../dropdown';
import { item, linkItem, inactiveItem, activeItem, contextStylesItem, contextStyles, DropdownHandle, navItemsStyles, navItemsPlaceholderStyles } from './styled';
/* eslint-disable @typescript-eslint/camelcase */

var ItemContent = function ItemContent(_a) {
  var context = _a.context,
      useHandleIcon = _a.useHandleIcon,
      toggled = _a.toggled;

  if (context) {
    return jsx(React.Fragment, null, jsx("span", {
      css: contextStylesItem
    }, ":"), jsx("span", {
      css: contextStyles
    }, context, " ", useHandleIcon && jsx(Icon, {
      content: toggled ? arrowUp_16 : arrowDown_16
    })));
  }

  return useHandleIcon ? jsx(Icon, {
    content: toggled ? arrowUp_16 : arrowDown_16
  }) : null;
};

function useReactElementsFilter() {
  var ref = React.useRef(null);
  React.useEffect(function () {
    if (!ref.current) {
      var domParser_1 = new DOMParser();

      ref.current = function (input, query) {
        return React.Children.toArray(input).filter(function (child) {
          var staticMarkup = renderToStaticMarkup(child);
          var html = domParser_1.parseFromString(staticMarkup, 'text/html');
          return html.documentElement.textContent && html.documentElement.textContent.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      };
    }
  }, []);
  return ref.current;
}

var Item = function Item(_a) {
  var active = _a.active,
      children = _a.children,
      context = _a.context,
      _b = _a.searchPlaceholder,
      searchPlaceholder = _b === void 0 ? 'Search' : _b,
      _c = _a.navItems,
      navItems = _c === void 0 ? null : _c,
      _d = _a.hasSearch,
      hasSearch = _d === void 0 ? false : _d;
  var strings = useLocalization(translations).strings;
  var filterReactElements = useReactElementsFilter();

  var _e = useToggle(false),
      toggled = _e[0],
      toggle = _e[1];

  var _f = React.useState(''),
      searchQuery = _f[0],
      setSearchQuery = _f[1];

  var onSearchChange = function onSearchChange(event) {
    return setSearchQuery(event.target.value);
  };

  var navItemsFiltered = navItems && filterReactElements ? filterReactElements(navItems, searchQuery) : navItems;

  if (navItems === null) {
    return jsx(React.Fragment, null, jsx("div", {
      css: [item, active ? activeItem : inactiveItem]
    }, cloneElementWithCss(children, [linkItem, active ? activeItem : inactiveItem]), jsx(ItemContent, {
      context: context
    })));
  }

  return navItems ? jsx(Dropdown, {
    handle: jsx(DropdownHandle, {
      onClick: toggle,
      role: "button",
      "aria-label": "Show navigation items"
    }, cloneElementWithCss(children, [item, linkItem, active ? activeItem : inactiveItem]), jsx(ItemContent, {
      useHandleIcon: true,
      context: context,
      toggled: toggled,
      onClick: toggle
    })),
    toggled: toggled,
    onOutsideClick: function onOutsideClick() {
      return toggled && toggle();
    },
    search: hasSearch ? {
      searchPlaceholder: searchPlaceholder,
      onSearchChange: onSearchChange,
      searchQuery: searchQuery
    } : undefined
  }, navItemsFiltered && navItemsFiltered.length > 0 ? navItemsFiltered.map(function (item) {
    return cloneElementWithCss(item, navItemsStyles(), {
      onClick: function onClick() {
        item.props.onClick && item.props.onClick();
        toggle();
      }
    });
  }) : jsx("span", {
    css: navItemsPlaceholderStyles()
  }, strings.select.nomatch)) : jsx(ItemContent, {
    context: context
  }, children);
};

export default Item;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/breadcrumbs/item.js
// module id = 922
// module chunks = 0